<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar color="primary" dark dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Driver Schedule
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-col>
                    <v-sheet height="90">
                        <v-toolbar flat>
                            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                                Today
                            </v-btn>
                            <v-btn fab text small color="grey darken-2" @click="prev">
                                <v-icon small>
                                    mdi-chevron-left
                                </v-icon>
                            </v-btn>
                            <v-btn fab text small color="grey darken-2" @click="next">
                                <v-icon small>
                                    mdi-chevron-right
                                </v-icon>
                            </v-btn>
                            <v-toolbar-title v-if="$refs.calendar">
                                {{ $refs.calendar.title }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-menu bottom right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                                        <span>{{ typeToLabel[type] }}</span>
                                        <v-icon right>
                                            mdi-menu-down
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item @click="type = 'day'">
                                        <v-list-item-title>Day</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="type = 'week'">
                                        <v-list-item-title>Week</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="type = 'month'">
                                        <v-list-item-title>Month</v-list-item-title>
                                    </v-list-item>

                                </v-list>
                            </v-menu>
                            <v-spacer></v-spacer>
                            <!-- <v-btn color="secondary" @click="loadScheduleAll" small>All <v-icon
                                    class="ml-2">mdi-account-group</v-icon></v-btn>
                            <v-spacer></v-spacer> -->
                            <v-spacer></v-spacer>
                            <v-switch label="DayOff" class="mr-2" hide-details dense color="red"
                                v-model="dayOff"></v-switch>
                            <v-spacer></v-spacer>
                            <v-combobox v-model="region" :items="regions" :item-text="'PrincipalRegion'"
                                :item-value="'PrincipalRegionID'" label="Select Region" auto-select-first dense
                                hide-details required></v-combobox>
                            <v-spacer></v-spacer>
                            <!-- <v-combobox label="Select Driver" :items="filteredCbx" hide-details dense
                                :item-text="'Name'" :item-value="'id'" auto-select-first v-model="driver"
                                @change="chargeData()"></v-combobox>
                            <v-spacer></v-spacer> -->
                            <v-combobox class="ml-4" label="Select Avg" :items="avgs" hide-details dense
                                auto-select-first v-model="avg"></v-combobox>
                            <v-spacer></v-spacer>
                            <v-btn color="primary"
                                @click="saveScheduleByDriver"><v-icon>mdi-content-save</v-icon></v-btn>
                        </v-toolbar>
                    </v-sheet>
                    <v-sheet>
                        <v-toolbar flat>
                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>General AVG</th>
                                        <th>Sunday</th>
                                        <th>Monday</th>
                                        <th>Tuesday</th>
                                        <th>Wednesday</th>
                                        <th>Thursday</th>
                                        <th>Friday</th>
                                        <th>Saturday</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(hr, idx) in hrs" v-bind:key="'hr-' + idx">
                                        <td v-if="hr.Type == avg">{{ hr.Type }}</td>
                                        <td v-if="hr.Type == avg"
                                            :style="avg == 'General' ? 'background:#1976D2;color:#fff;' : ''">{{
                                                hr.AvgDt }}
                                        </td>
                                        <td v-if="hr.Type == avg"
                                            :style="avg == 'AvgHrs' && hr.Type == 'AvgHrs' ? 'background:#1976D2;color:#fff;' : avg == 'AvgModa' && hr.Type == 'AvgModa' ? 'background:#1976D2;color:#fff;' : ''">
                                            {{ hr.Sunday }}</td>
                                        <td v-if="hr.Type == avg"
                                            :style="avg == 'AvgHrs' && hr.Type == 'AvgHrs' ? 'background:#1976D2;color:#fff;' : avg == 'AvgModa' && hr.Type == 'AvgModa' ? 'background:#1976D2;color:#fff;' : ''">
                                            {{ hr.Monday }}</td>
                                        <td v-if="hr.Type == avg"
                                            :style="avg == 'AvgHrs' && hr.Type == 'AvgHrs' ? 'background:#1976D2;color:#fff;' : avg == 'AvgModa' && hr.Type == 'AvgModa' ? 'background:#1976D2;color:#fff;' : ''">
                                            {{ hr.Tuesday }}</td>
                                        <td v-if="hr.Type == avg"
                                            :style="avg == 'AvgHrs' && hr.Type == 'AvgHrs' ? 'background:#1976D2;color:#fff;' : avg == 'AvgModa' && hr.Type == 'AvgModa' ? 'background:#1976D2;color:#fff;' : ''">
                                            {{ hr.Wednesday }}</td>
                                        <td v-if="hr.Type == avg"
                                            :style="avg == 'AvgHrs' && hr.Type == 'AvgHrs' ? 'background:#1976D2;color:#fff;' : avg == 'AvgModa' && hr.Type == 'AvgModa' ? 'background:#1976D2;color:#fff;' : ''">
                                            {{ hr.Thursday }}</td>
                                        <td v-if="hr.Type == avg"
                                            :style="avg == 'AvgHrs' && hr.Type == 'AvgHrs' ? 'background:#1976D2;color:#fff;' : avg == 'AvgModa' && hr.Type == 'AvgModa' ? 'background:#1976D2;color:#fff;' : ''">
                                            {{ hr.Friday }}</td>
                                        <td v-if="hr.Type == avg"
                                            :style="avg == 'AvgHrs' && hr.Type == 'AvgHrs' ? 'background:#1976D2;color:#fff;' : avg == 'AvgModa' && hr.Type == 'AvgModa' ? 'background:#1976D2;color:#fff;' : ''">
                                            {{ hr.Saturday }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <v-spacer></v-spacer>
                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <!-- <th>Variable Cycle</th> -->
                                        <th>Cycle</th>
                                        <th>Duty</th>
                                        <th>Driving</th>
                                        <th>Workday</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <!-- <td>{{ timeRest == null ? null : cycle }}</td> -->
                                        <td>{{ timeRest == null ? null : timeRest.cycle }}</td>
                                        <td>{{ timeRest == null ? null : timeRest.duty }}</td>
                                        <td>{{ timeRest == null ? null : timeRest.driving }}</td>
                                        <td>{{ timeRest == null ? null : timeRest.workday }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-toolbar>
                    </v-sheet>
                    <v-sheet v-if="type == 'month'">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th>Month</th>
                                    <th v-for="(day, idx) in month" v-bind:key="'day - ' + idx">
                                        {{ day.day }}<br>
                                        {{ day.weekday }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(driver, idx) in scheuduleByRegion" v-bind:key="'driver - ' + idx">
                                    <td>
                                        {{ driver.Driver }}
                                    </td>
                                    <template v-for="day in month">
                                        <td style="border:.5px solid #000;padding:10px;" class="month"
                                            @mouseenter="hoverDriver(driver, day.date)"
                                            @click="assingScheduleWeek(day, driver)">
                                            <template v-for="(sch) in driver.schedule">
                                                <span
                                                    :style="sch.date == day.date ? 'padding:10px;color:#fff;background:' + sch.color + ';' : ''"
                                                    @contextmenu.prevent="$refs.menuGo.open($event, sch)">
                                                    {{ sch.date == day.date ? sch.dayOff == false ? sch.shift : 'OFF' :
                                                    null }}
                                                </span>
                                            </template>
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-sheet>
                    <v-sheet class="mt-2" v-if="type == 'week'" max-height="800px">
                        <v-simple-table height="800px">
                            <thead>
                                <tr>
                                    <th>Week</th>
                                    <th v-for="(day, idx) in week" v-bind:key="'weekday - ' + idx">
                                        <span
                                            :style="focus == day.date ? 'background:#000; border-radius:50%;' : 'background:#000;'"></span>{{
                                                day.day }}<br>
                                        {{ day.weekday }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(driver, idx) in scheuduleByRegion" v-bind:key="'week-driver - ' + idx">
                                    <td @click="selectDriver(driver.DriverID)">
                                        {{ driver.Driver }}
                                    </td>
                                    <template v-for="day in week">
                                        <td style="border:.5px solid #000;" @mouseenter="hoverDriver(driver, day.date)"
                                            @click="assingScheduleWeek(day, driver)">
                                            <template v-for="(sch) in driver.schedule">
                                                <span @contextmenu.prevent="$refs.menuGo.open($event, sch)"
                                                    v-if="sch.date == day.date"
                                                    :style="sch.date == day.date ? 'padding:10px;color:#fff;background:' + sch.color + ';' : ''">
                                                    {{ sch.date == day.date ? sch.name : null }}
                                                </span>
                                            </template>
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-sheet>
                    <v-sheet class="mt-2" v-if="type == 'day'" max-height="800px">
                        <v-simple-table height="800px">
                            <thead>
                                <tr>
                                    <th width="20%">Drivers</th>
                                    <th>
                                        {{ focus }}
                                        {{ dayWeek }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(driver, idx) in scheuduleByRegion" v-bind:key="'week-driver - ' + idx"
                                    @mouseenter="hoverDriver(driver, null)">
                                    <td>
                                        {{ driver.Driver }}
                                    </td>
                                    <td style="border:.5px solid #000;" @click="clickByDay(driver)">
                                        <template v-for="(sch) in driver.schedule">
                                            <span @contextmenu.prevent="$refs.menuGo.open($event, sch)"
                                                :style="sch != null ? 'padding-top:10px;padding-bottom:10px;padding-left:30%;padding-right:30%;color:#fff;background:' + sch.color + ';' : ''"
                                                v-if="sch.date == focus">
                                                {{ sch != null ? sch.name : null }}
                                            </span>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-sheet>
                </v-col>
                <div v-if="showContextMenu"
                    :style="{ top: `${contextMenuPosition.y}px`, left: `${contextMenuPosition.x}px` }"
                    class="context-menu">
                    <ul v-if="driver === null" style="list-style: none;">

                        <li @click="viewMonth"><v-icon class="mr-2 my-2">mdi-calendar-range</v-icon> <span
                                class="mr-2">View
                                Month</span></li>
                        <li @click="viewWeek"><v-icon class="mr-2 my-2">mdi-view-week</v-icon> <span class="mr-2">View
                                Week</span></li>
                        <li @click="viewDay"><v-icon class="mr-2 my-2">mdi-calendar-week-begin</v-icon> <span
                                class="mr-2">View
                                Day</span></li>
                        <li @click="editEvent(null, 0)"><v-icon class="mr-2 my-2">mdi-calendar-edit</v-icon> <span
                                class="mr-2">Edit
                                Schedule </span></li>
                        <li @click="showContextMenu = false;"><v-icon class="mr-2 my-2">mdi-cancel</v-icon>Cancel </li>
                    </ul>
                    <ul v-if="status && driver != null">
                        <li @click="editEvent(null, 0)">Edit Schedule <v-icon
                                class="float-right ml-2">mdi-calendar-edit</v-icon>
                        </li>
                        <li @click="deleteEvent">Delete Schedule <v-icon
                                class="float-right ml-2">mdi-delete-circle</v-icon></li>
                        <li @click="showContextMenu = false;">Cancel <v-icon
                                class="float-right ml-2">mdi-cancel</v-icon></li>
                    </ul>
                    <ul v-if="!status && driver != null">
                        <li @click="editEvent(null, 0)">Edit Schedule <v-icon
                                class="float-right ml-2">mdi-calendar-edit</v-icon>
                        <li @click="showContextMenu = false;">Cancel <v-icon
                                class="float-right ml-2">mdi-cancel</v-icon></li>
                        </li>
                    </ul>
                </div>
            </v-container>
        </v-card>

        <vue-context ref="menuGo" dense>
            <template slot-scope="selected" v-if="selected.data">
                <!-- <li class="pr-2" @click="viewMonth"><v-icon class="mr-2 my-2">mdi-calendar-range</v-icon> View Month
                </li>
                <li class="pr-2" @click="viewWeek"><v-icon class="mr-2 my-2">mdi-view-week</v-icon> View Week</li>
                <li class="pr-2" @click="viewDay"><v-icon class="mr-2 my-2">mdi-calendar-week-begin</v-icon> View Day
                </li> -->
                <li class="pr-2" @click="editEvent(selected.data, 1)"><v-icon
                        class="mr-2 my-2">mdi-calendar-edit</v-icon>Edit Schedule</li>

                <!-- <li class="pr-2" @click="showContextMenu = false;"><v-icon class="mr-2 my-2">mdi-cancel</v-icon>Cancel
                </li> -->
            </template>
        </vue-context>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        <editSchedule v-if="shlModal" :event="selectedEvent" :shlModal="shlModal" @close="refreshSchedule">
        </editSchedule>
    </v-container>
</template>
<script>
import axios from "axios";
import moment from "moment";
import ConfirmDialogue from '@/components/Modals/ConfirmDialogue.vue';
import editSchedule from '@/components/Modals/Dispatch/ScheduleDriver/EditSchedule.vue';
import VueContext from 'vue-context';
import _ from 'lodash';
import { mask } from 'vue-the-mask';

export default {
    directives: { mask },
    components: {
        VueContext,
        ConfirmDialogue,
        editSchedule
    },

    data: () => ({
        categories: null,
        timeHrs: null,
        timeRest: null,
        status: null,
        shlModal: false,
        focus: moment().format('YYYY-MM-DD'),
        type: 'month',
        avgs: ['AvgHrs', 'AvgModa'],
        dayOff: 0,
        startTime: null,
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        drivers: [],
        driver: null,
        hrs: [],
        regions: null,
        region: null,
        avg: null,
        date: null,
        cont: 0,
        month: null,
        typeToLabel: {
            month: 'Month',
            week: 'Week',
            day: 'Day',
        },
        cycle: null,
        events: [
            // Aquí defines los eventos con sus fechas y colores
        ],
        dayWeek: '',
        today: moment().format('YYYY-MM-DD'), // Formato YYYY-MM-DD
        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
        byDriver: [],
        dayEvents: null,
        showContextMenu: false,
        contextMenuPosition: { x: 0, y: 0 },
        selectedEvent: null,
        startTimes: null,
    }),
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = 'Schedule';
            }
        },
    },
    computed: {
        scheuduleByRegion() {
            return this.byDriver.filter(i => {
                return !this.region || i.PrincipalRegionID == this.region.PrincipalRegionID;
            });
        },
    },
    async mounted() {
        this.startTimeHrs();
        this.dayWeek = moment(this.focus).format('dddd');
        this.month = await this.getDaysInCurrentMonthWithWeekdays();
        this.week = await this.getWeekInfo();
        this.loadRegions();
        this.cycleHrs();
    },
    methods: {
        refreshSchedule: function () {
            this.shlModal = false;
            this.loadScheduleAllByDriver();
        },
        startTimeHrs: function () {
            axios
                .get('driver-times/all', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.startTimes = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        assingScheduleWeek: async function (itm, driver) {
            this.focus = itm.date;
            this.clickByDay(driver);
            console.log(itm, driver);
        },
        selectDriver: async function (driver) {
            const idx = await this.drivers.findIndex(x => {
                return x.id == driver;
            });

            console.log(idx, driver);
            this.driver = this.drivers[idx];
            const parms = {
                Driver: driver
            }
            this.type = 'month';
            this.loadSchedule();
            axios
                .post('driver-times', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.hrs = response.data;
                    if (this.avg == null) {
                        this.avg = this.avgs[1];
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getDaysInCurrentMonthWithWeekdays: function () {
            const date = new Date(this.focus);
            const year = date.getFullYear();
            const month = date.getMonth();

            // Get the last day of the current month
            const lastDay = new Date(year, month + 1, 0).getDate();

            // Array with the names of the weekdays
            const weekdays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

            // Create an array with the days of the month and their weekdays
            const days = [];
            for (let i = 1; i <= lastDay; i++) {
                const currentDay = new Date(year, month, i);
                const dayOfWeek = weekdays[currentDay.getDay()];
                const fullDate = currentDay.toISOString().split('T')[0]; // Format YYYY-MM-DD
                days.push({ day: i, weekday: dayOfWeek, date: fullDate });
            }

            console.log(days);
            return days;
        },
        getWeekInfo: function () {
            const now = new Date(this.focus);
            const dayOfWeek = now.getDay(); // 0 (Sunday) to 6 (Saturday)

            // Calculate the start of the week (Sunday)
            const startOfWeek = new Date(now);
            startOfWeek.setDate(now.getDate() - dayOfWeek);

            // Create an array to hold the week days
            const weekDays = [];

            // Define an array with the names of the days of the week
            const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

            // Populate the array with dates and day names from Sunday to Saturday
            for (let i = 0; i < 7; i++) {
                const currentDay = new Date(startOfWeek);
                currentDay.setDate(startOfWeek.getDate() + i);

                const dayName = dayNames[currentDay.getDay()];
                const dayNumber = currentDay.getDate(); // Day of the month
                const formattedDate = currentDay.toISOString().split('T')[0]; // Format YYYY-MM-DD

                weekDays.push({ date: formattedDate, weekday: dayName, day: dayNumber });
            }
            console.log(weekDays)
            return weekDays;
        },
        loadRegions: function () {
            this.$store.state.isLoading = true;
            axios
                .get('regions', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.regions = response.data;
                    this.loadScheduleAllByDriver();
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        viewDay() {
            console.log(this.focus);
            this.type = 'day';
            this.showContextMenu = false;
        },
        viewWeek() {
            console.log(this.focus);
            this.type = 'week';
            this.showContextMenu = false;
        },
        viewMonth() {
            console.log(this.focus);
            this.type = 'month';
            this.showContextMenu = false;

        },
        async deleteSchedule(id, idx) {
            var str = this.$store;
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this schedule',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                str.state.isLoading = true;
                axios
                    .delete('schedule/' + id, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        str.state.isLoading = false;
                        this.events.splice(idx, 1);
                    })
                    .catch(function (error) {
                        str.state.isLoading = false;
                        console.log(error);
                    });
            }
        },
        handleEventClick(event) {
            console.log('Evento clickeado:', event);
        },
        disabledDate(date) {
            // Disable dates before today
            return date < new Date();
        },
        getEventColor({ start }) {
            const event = this.events.find(event => event.start === start);
            return event ? event.color : null;
        },
        calculateTime: function (hora) {
            let [hh, mm, ss] = hora.split(':').map(Number);
            // Convertir todo a segundos para simplificar la resta
            let totalSegundos = hh * 3600 + mm * 60 + ss;
            return Math.floor(totalSegundos / 3600);
        },
        calculateHrs: function (hora, horasRestar, action) {
            // Descomponer la hora en componentes de horas, minutos y segundos
            console.log(hora);
            let [hh, mm, ss] = hora.split(':').map(Number);

            // Convertir todo a segundos para simplificar la resta
            let totalSegundos = hh * 3600 + mm * 60 + ss;

            // Restar las horas en segundos
            if (action == true) {
                totalSegundos += horasRestar * 3600;
            } else {
                totalSegundos -= horasRestar * 3600;
            }

            // Asegurarse de que los segundos sean no negativos
            if (totalSegundos < 0) {
                totalSegundos += 24 * 3600; // Ajuste para un ciclo de 24 horas
            }

            // Convertir los segundos de vuelta a horas, minutos y segundos
            hh = Math.floor(totalSegundos / 3600);
            totalSegundos %= 3600;
            mm = Math.floor(totalSegundos / 60);
            ss = totalSegundos % 60;

            // Asegurarse de que los componentes tengan dos dígitos
            hh = String(hh).padStart(2, '0');
            mm = String(mm).padStart(2, '0');
            ss = String(ss).padStart(2, '0');

            // Retornar el resultado en formato hh:mm:ss
            return `${hh}:${mm}:${ss}`;
        },
        checkDay: function (day) {
            let weekday;
            switch (day) {
                case 0:
                    weekday = 'Sunday';
                    break;
                case 1:
                    weekday = 'Monday';
                    break;
                case 2:
                    weekday = 'Tuesday';
                    break;
                case 3:
                    weekday = 'Wednesday';
                    break;
                case 4:
                    weekday = 'Thursday';
                    break;
                case 5:
                    weekday = 'Friday';
                    break;
                case 6:
                    weekday = 'Saturday';
                    break;
            }
            return weekday;
        },
        saveSchedule: async function () {
            var str = this.$store;
            const insert = await this.events.filter(y => {
                return y.register == 0;
            }).map(x => {
                return {
                    Driver: this.driver.id,
                    Date: x.start,
                    HourStart: x.time,
                    DayOff: x.dayOff,
                    Shift: x.shift,
                    WorkHrs: x.workHrs,
                    EndDate: x.end,
                    Cycle: x.cycle,
                }
            });
            var parms = {
                Insert: insert,
                Driver: this.driver.id,
                Today: this.today,
            }
            console.log(parms);
            str.state.isLoading = true;
            axios
                .post('schedule/register/dates', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.events = response.data;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Schedule successfully saved'
                    });
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        saveScheduleByDriver: async function () {
            var str = this.$store;
            console.log(this.byDriver)
            const insert = await this.byDriver.filter(y => {
                const reg = y.schedule.filter(z => {
                    return z.register === 0;
                }).map(x => {
                    return {
                        Driver: y.DriverID,
                        Date: x.start,
                        HourStart: x.time,
                        DayOff: x.dayOff,
                        Shift: x.shift,
                        WorkHrs: x.workHrs,
                        EndDate: x.end,
                        // Cycle: x.cycle,
                    }
                });
                y.schedule = reg;
                return reg.length > 0;
            }).map(x => {
                return x.schedule
            });
            // 
            var parms = {
                Insert: insert,
                // Driver: this.driver.id,
                Today: this.today,
            }
            console.log(parms);
            str.state.isLoading = true;
            axios
                .post('schedule/register/dates/by/date', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.loadScheduleAllByDriver();
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Schedule successfully saved'
                    });
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        loadSchedule: function () {
            this.events = [];
            axios
                .get('schedule/recorded/' + this.today + '/' + this.driver.id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.events = response.data;
                    const idx = this.timeHrs.findIndex(x => {
                        return x.driver == this.driver.id;
                    });
                    this.timeRest = this.timeHrs[idx];
                    this.cycle = this.timeRest.cycle;
                    console.log(this.timeRest);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadScheduleAllByDriver: function () {
            this.driver = null;
            axios
                .get('schedule/all/by/driver', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.byDriver = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getAMPM: function (time) {
            const [hours, minutes, second] = time.split(':').map(Number);
            const period = hours >= 12 ? 'PM' : 'AM';

            return period;
        },
        getEventColor(event) {
            return event.color
        },
        setToday() {
            this.focus = moment().format('YYYY-MM-DD');
        },
        async prev() {
            const day = moment(this.focus);
            switch (this.type) {
                case 'day':
                    console.log(this.focus);
                    await day.subtract(1, 'days');
                    this.focus = day.format("YYYY-MM-DD");
                    this.week = await this.getWeekInfo();
                    break;
                case 'week':
                    console.log(this.focus)
                    day.subtract(7, 'days');
                    this.focus = day.format("YYYY-MM-DD");
                    this.week = await this.getWeekInfo();
                    this.type = 'day';
                    this.type = 'week';
                    break
                case 'month':
                    await day.subtract(30, 'days');
                    this.focus = day.format("YYYY-MM-DD");
                    console.log(this.focus)
                    this.month = await this.getDaysInCurrentMonthWithWeekdays();
                    this.week = await this.getWeekInfo();
                    this.type = 'day';
                    this.type = 'month';
                break;
                
            }

            this.dayWeek = moment(this.focus).format('dddd');
        },
        async next() {
            const day = moment(this.focus);
            switch (this.type) {
                case 'day':
                    console.log(this.focus)
                    await day.add(1, 'days');
                    this.focus = day.format("YYYY-MM-DD");
                    this.month = await this.getDaysInCurrentMonthWithWeekdays();
                    this.week = await this.getWeekInfo();
                    break;
                case 'week':
                    console.log(this.focus)
                    await day.add(7, 'days');
                    this.focus = day.format("YYYY-MM-DD");
                    this.month = await this.getDaysInCurrentMonthWithWeekdays();
                    this.week = await this.getWeekInfo();
                    this.type = 'day';
                    this.type = 'week';
                    break;
                case 'month':
                    console.log(this.focus)
                    await day.add(31, 'days');
                    this.focus = day.format("YYYY-MM-DD");
                    this.month = await this.getDaysInCurrentMonthWithWeekdays();
                    this.week = await this.getWeekInfo();
                    this.type = 'day';
                    this.type = 'month';
                break;
            }
            this.dayWeek = moment(this.focus).format('dddd');
        },
        showEvent({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                open()
            }

            nativeEvent.stopPropagation()
        },
        updateRange({ start, end }) {
            const events = []

            const min = new Date(`${start.date}T00:00:00`)
            const max = new Date(`${end.date}T23:59:59`)
            const days = (max.getTime() - min.getTime()) / 86400000
            const eventCount = this.rnd(days, days + 20)

            for (let i = 0; i < eventCount; i++) {
                const allDay = this.rnd(0, 3) === 0
                const firstTimestamp = this.rnd(min.getTime(), max.getTime())
                const first = new Date(firstTimestamp - (firstTimestamp % 900000))
                const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
                const second = new Date(first.getTime() + secondTimestamp)

                events.push({
                    name: this.names[this.rnd(0, this.names.length - 1)],
                    start: first,
                    end: second,
                    color: this.colors[this.rnd(0, this.colors.length - 1)],
                    timed: !allDay,
                })
            }

            this.events = events
        },
        rnd(a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a
        },
        handleEventContextMenu(event, e) {
            e.preventDefault();
            this.selectedEvent = event.event;
            this.focus = event.event.date;
            console.log(this.focus);
            if (event.event.register == 1) {
                this.status = 1;
            } else {
                this.status = 0;
            }
            this.contextMenuPosition = { x: e.clientX - 50, y: e.clientY - 50 };
            this.showContextMenu = true;
        },
        editEvent(data, status) {
            if (status == 1) {
                if (data.register == 1) {
                    this.status = 1;
                } else {
                    this.status = 0;
                }
                this.selectedEvent = data;
                console.log('here data', data);
            }
            this.shlModal = true;
            this.showContextMenu = false;
        },
        deleteEvent() {
            const id = this.selectedEvent.id;
            console.log(this.selectedEvent.id);
            const idx = this.events.findIndex(x => {
                return x.id == id;
            })
            this.deleteSchedule(id, idx);
            this.showContextMenu = false;
        },
        cycleHrs: function () {
            // schedule/time/drivers
            axios
                .get('schedule/time/drivers', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.timeHrs = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getDiffHrs: function (date1, date2) {
            console.log(date1, date2);
            // Obtener las marcas de tiempo en milisegundos
            let time1 = new Date(date1).getTime();
            let time2 = new Date(date2).getTime();

            // Calcular la diferencia en milisegundos
            let diffSeconds = Math.abs(time2 - time1);

            // Convertir la diferencia de milisegundos a horas
            let diffHrs = diffSeconds / (1000 * 60 * 60);

            return diffHrs;
        },
        getRowWithMaxDate: function (rows) {
            return rows.reduce((max, row) => {
                return new Date(row.date) > new Date(max.date) ? row : max;
            });
        },
        addDayOff: async function (evt, weekday) {
            let time; let ix; let shift; let endTime; let hora; let cycle; let hrs; let shiftHrs;

            ix = this.hrs.findIndex(x => {
                return x.Type == 'AvgHrs';
            });
            time = this.hrs[ix][weekday];

            if (time == null) {
                time = this.hrs[ix]['AvgDt'];
            }

            endTime = moment(evt.date + " " + time);
            shift = await this.getAMPM(time);
            hrs = this.calculateTime(this.cycle);
            shiftHrs = 12;
            hora = endTime.add(shiftHrs, 'hours');
            this.events.push({ start: evt.date + ' ' + time, end: hora.format('YYYY-MM-DD HH:mm'), date: evt.date, workHrs: shiftHrs, driver: this.driver.id, register: 0, shift: shift, dayOff: this.dayOff, color: this.dayOff == 1 ? 'red' : '#78909C', name: this.dayOff == 1 ? ' DayOff' : 'Shift :' + shift, time: time, Region: this.driver.Region, cycle: this.cycle })
        },
        addRows: async function (evt, weekday) {
            let time; let ix; let shift; let endTime; let hora; let cycle; let hrs; let shiftHrs;
            switch (this.avg) {
                case 'General':
                    time = this.hrs[0]['AvgDt'];
                    endTime = moment(evt.date + " " + time);
                    shift = await this.getAMPM(time);
                    hrs = this.calculateTime(this.cycle);
                    if (hrs < 12) {
                        shiftHrs = hrs;
                    } else {
                        shiftHrs = 12;
                    }
                    hora = endTime.add(shiftHrs, 'hours');
                    cycle = this.calculateHrs(this.cycle, shiftHrs, 0);
                    this.cycle = cycle;
                    this.events.push({ start: evt.date + ' ' + time, end: hora.format('YYYY-MM-DD HH:mm'), date: evt.date, workHrs: shiftHrs, driver: this.driver.id, register: 0, shift: shift, dayOff: this.dayOff, color: this.dayOff == 1 ? 'red' : '#78909C', name: this.dayOff == 1 ? ' DayOff' : 'Shift :' + shift, time: time, Region: this.driver.Region, cycle: cycle })
                    break;
                case 'AvgHrs':
                    ix = this.hrs.findIndex(x => {
                        return x.Type == 'AvgHrs';
                    });

                    time = this.hrs[ix][weekday];

                    shift = await this.getAMPM(time);
                    hrs = this.calculateTime(this.cycle);
                    if (hrs < 12) {
                        shiftHrs = hrs;
                    } else {
                        shiftHrs = 12;
                    }
                    endTime = moment(evt.date + " " + time);
                    hora = endTime.add(shiftHrs, 'hours');
                    cycle = this.calculateHrs(this.cycle, shiftHrs, 0);
                    this.cycle = cycle;
                    this.events.push({ start: evt.date + ' ' + time, end: hora.format('YYYY-MM-DD HH:mm'), date: evt.date, workHrs: shiftHrs, driver: this.driver.id, register: 0, shift: shift, dayOff: this.dayOff, color: this.dayOff == 1 ? 'red' : '#78909C', name: this.dayOff == 1 ? ' DayOff' : 'Shift :' + shift, time: time, Region: this.driver.Region, cycle: cycle })
                    break;
                case 'AvgModa':
                    ix = this.hrs.findIndex(x => {
                        return x.Type == 'AvgModa';
                    });
                    time = this.hrs[ix][weekday];
                    endTime = moment(evt.date + " " + time);
                    shift = await this.getAMPM(time);
                    hrs = this.calculateTime(this.cycle);
                    if (hrs < 12) {
                        shiftHrs = hrs;
                    } else {
                        shiftHrs = 12;
                    }
                    hora = endTime.add(shiftHrs, 'hours');
                    cycle = this.calculateHrs(this.cycle, shiftHrs, 0);
                    this.cycle = cycle;
                    this.events.push({ start: evt.date + ' ' + time, end: hora.format('YYYY-MM-DD HH:mm'), date: evt.date, workHrs: shiftHrs, driver: this.driver.id, register: 0, shift: shift, dayOff: this.dayOff, color: this.dayOff == 1 ? 'red' : '#78909C', name: this.dayOff == 1 ? ' DayOff' : 'Shift :' + shift, time: time, Region: this.driver.Region, cycle: cycle })
                    break;
            }
        },
        getLastDate: function (datos, fechaActual) {
            console.log(datos, fechaActual);
            return datos
                .filter(item => {
                    return item.date < fechaActual && item.dayOff == 0;
                }) // Filtrar fechas anteriores a la fecha actual
                .sort((b, a) => new Date(a.date) - new Date(b.date)) // Ordenar fechas en orden descendente
            [0]; // Seleccionar la primera fecha
        },
        hoverDriver: function (driver, day) {
            const idxCycle = this.timeHrs.findIndex(x => {
                return x.driver == driver.DriverID;
            });
            const idxStart = this.startTimes.findIndex(x => {
                return x.Driver == driver.DriverID;
            });

            this.hrs = this.startTimes[idxStart]['StartTimes'];

            if (this.avg == null) {
                this.avg = this.avgs[1];
            }
            this.timeRest = this.timeHrs[idxCycle];

            // if(this.type){ this.focus = day;}
            const dayPrev = moment(this.focus);
            const prev = dayPrev.subtract(1, 'days').format('YYYY-MM-DD');
            const idxCl = driver['schedule'].findIndex(x => {
                return x.date == this.focus;
            });
            const idxPrv = driver['schedule'].findIndex(x => {
                return x.date == prev;
            });

            if (idxCl < 0) {
                if (idxPrv < 0) {
                    this.cycle = this.timeRest.cycle;
                } else {
                    this.cycle = driver.schedule[idxPrv]['cycle'];
                }
            } else {
                this.cycle = driver.schedule[idxCl]['cycle'];
            }

        },
        clickByDay: async function (evt) {
            console.log(evt, this.today);
            //Date, weekday
            // let cycle;
            const idxDrv = this.scheuduleByRegion.findIndex(x => {
                return x.DriverID === evt.DriverID;
            });
            let date = moment(this.focus)
            const weekday = date.format('dddd');
            const idx = await evt['schedule'].findIndex(x => {
                return x.date === this.focus;//&& evt.DriverID == x.Drirver;
            });
            console.log(idx);
            let time; let ix; let shift; let endTime; let hora; let cycle; let hrs; let shiftHrs;
            if (this.focus >= this.today) {
                if (idx >= 0) {
                    if (this.scheuduleByRegion[idxDrv]['schedule'][idx].register == 0) {
                        console.log(this.scheuduleByRegion[idxDrv]['schedule'][idx]);
                        this.scheuduleByRegion[idxDrv]['schedule'].splice(idx, 1);
                    }
                } else {
                    const ix = this.hrs.findIndex(x => {
                        return x.Type == this.avg;
                    });
                    console.log(ix);
                    time = this.hrs[ix][weekday];
                    console.log(time, 'Here Time');
                    console.log('time', time);
                    endTime = moment(this.focus + " " + time);
                    shift = await this.getAMPM(time);
                    // shift = "PM";
                    // hrs = this.calculateTime(this.cycle);

                    shiftHrs = 12;
                    hora = endTime.add(shiftHrs, 'hours');
                    this.scheuduleByRegion[idxDrv]['schedule'].push({ start: this.focus + ' ' + time, end: hora.format('YYYY-MM-DD HH:mm'), date: this.focus, workHrs: shiftHrs, driver: evt.DriverID, register: 0, shift: shift, dayOff: this.dayOff, color: this.dayOff == 1 ? 'red' : '#78909C', name: this.dayOff == 1 ? ' DayOff' : 'Shift :' + shift + ' WorkHrs ' + shiftHrs + ' ' + this.focus + ' ' + time + ' - ' + hora.format('YYYY-MM-DD HH:mm'), time: time, register: 0 });
                    console.log(this.scheuduleByRegion);
                }
            }
        },
    }

}
</script>
<style scoped>
td {
    padding: 2px;
    text-align: center;
}

.context-menu {
    position: absolute;
    background-color: white;
    border: 1px solid #ccc;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    z-index: 1000;
}

.context-menu ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.context-menu li {
    padding: 8px 12px;
    cursor: pointer;
}

.context-menu li:hover {
    background-color: #eee;
}
</style>
<style>
.calendar-container {
    display: flex;
    overflow: hidden;
}

.calendar-categories {
    width: 200px;
    /* Ajusta el ancho según sea necesario */
    overflow-y: auto;
    overflow-x: hidden;
}

.calendar-events-container {
    flex: 1;
    overflow: auto;
}

.category-label {
    height: 48px;
    /* Ajusta la altura para que coincida con la altura de los eventos */
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #ccc;
}
</style>
